<p class="red" [ngClass]="color">
  {{ time | date : 'dd.MM.yyyy' : 'UTC-0' }} <br *ngIf="!line">
  {{ time | date : 'HH:mm' : 'UTC-0' }}
</p>

